import { CryptoJsService } from './../../services/crypto-js.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import jwtDecode from 'jwt-decode';
import { Message, MessageService } from 'primeng/api';
import { first, shareReplay, Subscription } from 'rxjs';
import { AppConfig } from 'src/app/models/appconfig';
import { ConfigService } from 'src/app/services/app.config.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { TranslateService } from '@ngx-translate/core';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { ReportsService } from 'src/app/services/reports.service';
import { log } from 'console';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styles: [`
    :host ::ng-deep .p-password input {
    width: 100%;
    padding:1rem;
    }

    :host ::ng-deep .pi-eye{
      transform:scale(1.6);
      margin-right: 1rem;
      color: var(--primary-color) !important;
    }

    :host ::ng-deep .pi-eye-slash{
      transform:scale(1.6);
      margin-right: 1rem;
      color: var(--primary-color) !important;
    }


    .siteUnderMaintenance{
      height: 100vh;
      background-color: #fcf2f4 ;
      font-family: Arial, sans-serif;
      text-align: center;
      padding: 50px;

      h1 {
          font-size: 1.6rem;
          color: #590101;
          margin-bottom: 20px;
          font-weight: bold !important;
      }

      p {
          font-size: 1.2rem;
          color: #ce1515;
          font-weight: bold !important;
      }

      .logo {
        margin-bottom: 40px;
        // mix-blend-mode: multiply;
        // max-width: 50px;
        // max-height: 50px;
        display: block;
        justify-content: center;
        img {
            width: 120px;
            height: 120px;
        }
      }

      .reload-button, .goback-button {
        margin-top: 20px;
      }

    }

    .sign-in-button{
      background-color: #8b5815;
    }
      
    .sign-in-button:hover{
      background-color: #8b5815;
    }

  `]
})
export class LoginComponent implements OnInit, OnDestroy {
  public onAuthForm: FormGroup;
  valCheck: string[] = ['remember'];
  wrongNotificationCheck: boolean = true;
  password: string;

  config: AppConfig;
  userData: any;
  subscription: Subscription;
  date: any;
  ipAddress: any;
  status: any;
  isSiteUnderMaintenance: boolean = false;
  subjectSub: any;
  selectedYear: any;
  public subscriptions: any = [];
  financialYears:any[]=[]

  constructor(
    private _formBuilder: FormBuilder, 
    private service1: BaseService, 
    public configService: ConfigService, 
    private authService: AuthenticationService, 
    public router: Router, 
    private service: MessageService, 
    private cryptoJs: CryptoJsService, 
    private translateService: TranslateService, 
    private messageService: MessageService, 
    private ipService: IpAddressService, 
    private activityRecordService: ActivityRecordService, 
    private loader: AppLoaderService,
    private reportsService: ReportsService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    this.getInitialToken();
    sessionStorage.removeItem('userID');

    this.getFinYear();
    this.onAuthForm = this._formBuilder.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
      remembercheck: ['', []],
    });

    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe(config => {
      this.config = config;
    });
    
    // this.subjectSub = this.service1
    //     .getSelectedYear()
    //     .pipe(shareReplay())
    //     .subscribe((res) => {
    //         let router = this.router.url;
    //         // this.routePath=router.split('/')
    //         this.subscriptions.forEach((sub) => sub.unsubscribe());
    //         this.selectedYear = res;

    //       });
    // this.getChartData('');
    // this.getChartData('2022-23');
    // this.getChartData('2023-24');
  }

  getInitialToken(){
    this.authService
      .getInitialToken()
      .pipe(first())
      .subscribe({
        next: (response) => {
          if (response){
            sessionStorage.setItem("token", response.data)
          }
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: `Next level user not found. ${err}`,
          // });
        },
      });
  }

  onLogin() {
    sessionStorage.removeItem("isFarmerLogin");
    sessionStorage.removeItem("isVendorLogin");
    
    let reqBody = {
      "username": this.f.email.value,
      "password": this.cryptoJs.Encrypt(this.f.password.value)
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJs.EncryptPayload(JSON.stringify(reqBody))
    }
    
    this.loader.start();
    this.authService.login(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          sessionStorage.setItem("token", resp.data)
          let data = JSON.parse(this.cryptoJsService.DecryptToken(resp.data));
          this.loader.close();
          this.activityRecordService.activityRecord(this.f.email.value, 'login', '', new Date(), 'Success');

          // console.log('data', data);
          
          const loginDetails = new Map();
          loginDetails.set('tokenInfo', data);
          loginDetails.set('User_name_while_login', this.f.email.value);
          loginDetails.set('loginUserName', data?.officerName);
          // sessionStorage.setItem("User_name_while_login", this.f.email.value);
          // sessionStorage.setItem("loginUserName", data?.officerName);


          const dataD = JSON.stringify(Array.from(loginDetails.entries()));
          // console.log('dataDL', loginDetails);
          sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

          this.userData = jwtDecode(data.authToken);


          if (data.role === 'DD Associate' || data.role === 'DMICADA' || data.role === 'DDMICADA' || data.role === 'ADVISOR' || data.role === 'DDMI' || data.role === 'DDTank') {
            // loginDetails.set('userRole', data.role);
            // loginDetails.set('deptUserID', this.f.email.value);
            // sessionStorage.setItem('userRole', data.role);
            // sessionStorage.setItem('isDepartment', '1');
            // sessionStorage.setItem('deptUserID', this.f.email.value);
            // sessionStorage.setItem(this.cryptoJs.Encrypt('canEditMIData'), this.cryptoJs.Encrypt('yes'));
            
            loginDetails.set('isDepartment', '1');
            loginDetails.set('canEditMIData', 'Yes');
           
            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            if (data.role === 'ADVISOR') {
              this.router.navigate(['/department/report/timeline']);
              // this.router.navigate(['/department/dashboard/micada_geography']);
            } else if (data.role === 'DMICADA') {
              this.router.navigate(['/department/report/consolidated-report-new']);
              // this.router.navigate(['/department/dashboard/micada_geography']);
            } else if (this.f.email.value === 'D.A-9') {
              this.router.navigate(['/department/pond/tank-stage1'])
            } else if (this.f.email.value === 'D.A-10') {
              this.router.navigate(['/department/unhide-application'])
            }
            else {
              this.router.navigate(['/department/farmer-applications']);
            }

            return;
          }

          else if (data.role == 'Vendor') {
            loginDetails.set('isVendor', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('isVendor', '1');
            // this.router.navigate(['/vendor/dashboard/dashoard-report-new']);
            this.router.navigate(['/vendor/pre-estimate-survey']);
            // sessionStorage.setItem('abyUserID', this.userData.sub);
            return;
          }
          else if (data.role == 'JE') {
            loginDetails.set('isJE', '1');
            loginDetails.set('editBilledData', 'Yes');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));
            
            this.router.navigate(['/je']);
            return;
          }
          else if (data.role == 'CJE') {
            loginDetails.set('isJE', '1');
            loginDetails.set('isCJE', '1');
            loginDetails.set('editBilledData', 'Yes');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('isJE', '1');
            // sessionStorage.setItem('isCJE', '1');
            // sessionStorage.setItem(this.cryptoJs.Encrypt('editBilledData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/cje']);
            return;
          }
          else if (data.role == 'SDO') {
            loginDetails.set('isSDO', '1');
            loginDetails.set('editBilledData', 'Yes');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('isSDO', '1');
            // sessionStorage.setItem(this.cryptoJs.Encrypt('editBilledData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/sdo']);
            return;
          }
          else if (data.role == 'XEN') {
            loginDetails.set('isXEN', '1');
            loginDetails.set('editBilledData', 'Yes');
            
            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('isXEN', '1');
            // sessionStorage.setItem(this.cryptoJs.Encrypt('editBilledData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/xen']);
            return;
          }
          else if (data.role == 'CXEN') {
            loginDetails.set('isXEN', '1');
            loginDetails.set('isCXEN', '1');
            loginDetails.set('editBilledData', 'Yes');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));
            
            // sessionStorage.setItem('isXEN', '1');
            // sessionStorage.setItem('isCXEN', '1');
            // sessionStorage.setItem(this.cryptoJs.Encrypt('editBilledData'), this.cryptoJs.Encrypt('yes'));
            this.router.navigate(['/cxen']);
            return;
          }
          else if (data.role == 'HelpDesk') {
            loginDetails.set('isHelpdesk', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('isHelpdesk', '1');
            this.router.navigate(['/helpdesk']);
            return;
          }
          else if (data.role == 'ADMIN') {
            loginDetails.set('isAdmin', '1');
            loginDetails.set('editBilledData', 'Yes');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            this.router.navigate(['/admin/report/consolidated-report-new']);
            // this.router.navigate(['/admin']);

            // sessionStorage.setItem('userRole', data.role);
            // sessionStorage.setItem('adminUserID', this.f.email.value);
            // sessionStorage.setItem(this.cryptoJs.Encrypt('canEditMIData'), this.cryptoJs.Encrypt('yes'));
            return;
          }
          // else if (data.role == 'ABY_agency') {
          //   loginDetails.set('isAtalBhujal', '1');
          //   loginDetails.set('atalBhujalUserID', this.userData.sub);
            
          //   const dataD = JSON.stringify(Array.from(loginDetails.entries()));
          //   sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));
            
          //   // sessionStorage.setItem('isAtalBhujal', '1');
          //   return;
          // }
          else if (data.role == 'CAO') {
            loginDetails.set('isCAO', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            this.router.navigate(['/cao/report/consolidated-report-new']);
            // sessionStorage.setItem('userRole', data.role);
            // sessionStorage.setItem('isCAO', '1');
            // this.router.navigate(['/cao']);
            return;
          }
          else if (data.role == 'Dev') {
            loginDetails.set('isDev', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            this.router.navigate(['/dev']);
            // sessionStorage.setItem('isDev', '1');
            return;
          }
          else if (data.role == 'SubDev') {
            loginDetails.set('isSubDev', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            this.router.navigate(['/subdev']);
            // sessionStorage.setItem('isSubDev', '1');
            return;
          }
          else if (data.role == 'JE-EW') {
            loginDetails.set('isJEEW', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('userRole', data.role);
            this.router.navigate(['/ew-je']);
            // sessionStorage.setItem('isJEEW', '1');
            return;
          }
          else if (data.role == 'DD-EW') {
            loginDetails.set('isDDEW', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('userRole', data.role);
            this.router.navigate(['/ew-department/report/consolidated-report-new']);
            // sessionStorage.setItem('isDDEW', '1');
            return;
          }
          else if (data.role == 'XEN Works') {
            loginDetails.set('isUserAction', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('userRole', data.role);
            this.router.navigate(['/user-action']);
            // sessionStorage.setItem('isUserAction', '1');
            return;
          }
          else if (data.role == 'Contractor') {
            loginDetails.set('isConstractor', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('userRole', data.role);
            this.router.navigate(['/contractor/new-work']);
            // sessionStorage.setItem('isConstractor', '1');
            return;
          }
          else if (data.role == 'Dev Team') {
            loginDetails.set('isDevTeam', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('userRole', data.role);
            this.router.navigate(['/ptg-dev-team']);
            // sessionStorage.setItem('isDevTeam', '1');
            return;
          }
          else if (data.role == 'GrievanceHandler') {
            loginDetails.set('isGrievanceHandler', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('userRole', data.role);
            this.router.navigate(['/grievance-handler']);
            // sessionStorage.setItem('isGrievanceHandler', '1');
            return;
          }
          else if (data.role == 'WebAdmin') {
            loginDetails.set('isWebAdmin', '1');

            const dataD = JSON.stringify(Array.from(loginDetails.entries()));
            sessionStorage.setItem('dataD', this.cryptoJsService.EncryptSessionD(dataD));

            // sessionStorage.setItem('userRole', data.role);
            this.router.navigate(['/webadmin']);
            // sessionStorage.setItem('isWebAdmin', '1');
            return;
          }
        // this.router.navigate(['/dashboard']);
        },
        error: (res) => {
          this.loader.close();
          let errorArray = res;

          this.activityRecordService.activityRecord(this.f.email.value, 'login', '', new Date(), JSON.stringify(errorArray));
          if (errorArray.length) {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: errorArray });
          } else {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Server Error' });
          }
        },
        // complete: () => {

        //   this.fetchDateTime();
        // },
      }
      );
  }

  get f() {
    return this.onAuthForm.controls;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // wrongNotification(event) {
  //   this.wrongNotificationCheck = !this.wrongNotificationCheck;

  //   if(event.value.name=='English')
  //   {
  //      this.translateService.use('en')
  //   }
  //   else{
  //       this.translateService.use('hd')
  //   }

  // }

  reloadPage(){
    window.location.reload();
  }

  goBack(){
    window.history.back();
  }

  getFinYear(){
    this.reportsService.getFinanacialYearList()
    .pipe(first())
    .subscribe({
      next: (data) => {

        data.forEach((e:any)=>{
          let year={name:e.FinancialYears,code:e.FinancialYears}
          
          
          this.financialYears.push(year)
          

        })
        this.selectedYear={...this.financialYears[2]}

        sessionStorage.setItem('yearList',  JSON.stringify(this.financialYears))
        sessionStorage.setItem('financialYear',this.selectedYear.code)
        let a= sessionStorage.getItem('financialYear')
        this.service1.changeFinancialYear(this.selectedYear.code)

       
      }})
  }
}
